import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { StateService } from '../../state/state.service';
import { Estimate } from '../../core/model/estimate';
import { EstimateDaoService } from '../../core/dao-service/estimate-dao.service';
import { OrdersDaoService } from '../../core/dao-service/orders-dao.service';
import { AddOrderIdCommand } from '../../state/order/order-commands';
import * as printJS from 'print-js';
import { Analytics } from '../../core/service/analytics';

@Component({
  selector: 'app-estimate-card',
  templateUrl: './estimate-card.component.html',
  styleUrls: ['./estimate-card.component.scss']
})
export class EstimateCardComponent implements OnInit, OnDestroy {
  @Input() estimate: Estimate;

  estimateSpinner: boolean;
  isEstimateProcessing$: Subscription;
  estimationId: string;

  constructor(
    private router: Router,
    private estimateService: EstimateDaoService,
    private ordersService: OrdersDaoService,
    private state: StateService,
    private analytics: Analytics,
  ) { }

  ngOnInit(): void {
    this.isEstimateProcessing$ = null;
    this.estimateSpinner = true;
    this.estimationId = this.state.snapshot.order.estimationId;
    this.estimateSpinner = false;
  }

  ngOnDestroy(): void {
    this.estimateSpinner = false;
    this.isEstimateProcessing$ ? this.isEstimateProcessing$.unsubscribe() : null;
  }

  acceptCostAndGoToInfoView() {
    if (this.isEstimateProcessing$) {
      return;
    }
    this.analytics.logEvent("click_estimate_accept");
    this.estimateSpinner = true;
    const orderPayload = {
      id_estimate: this.estimationId,
      isOnlineOrder: this.estimate.isOnlineEstimate,
      privacyAccepted: this.estimate.isOnlineEstimate
    };
    this.isEstimateProcessing$ = this.estimateService.put(this.estimationId, { state: 'accettato' }, "state")
      .switchMap(() => this.ordersService.post(orderPayload))
      .do(res => this.state.execute(new AddOrderIdCommand(res.key)))
      .subscribe(() => {
        if (this.estimate.isOnlineEstimate) {
          this.router.navigate(['ecommerce', 'phone-description']);
        } else {
          this.router.navigate(['shop', 'order-new', 'phone-description']);
        }
      });
  }

  declineCostGoToOrderList() {
    if (this.isEstimateProcessing$) {
      return;
    }

    this.estimateSpinner = true;
    this.analytics.logEvent("click_estimate_decline");

    this.isEstimateProcessing$ = this.estimateService.put(this.estimationId, { state: 'rifiutato' }, "state")
      .subscribe(() => {
        if (this.estimate.isOnlineEstimate) {
          this.router.navigate(['ecommerce', 'start'])
        } else {
          this.router.navigate(['shop', 'order-new', 'brand-choice']);
        }
      });
  }

  printPage() {
    this.analytics.logEvent("click_estimate_print");
    printJS({
      printable: 'print-section',
      type: 'html',
      header: '<div><div style="float:left; width:32%;margin-bottom:110px;margin-top:40px;margin-left:20px;"><img src="../../../assets/images/geniuslogonuovo01.svg" alt="GeniusRepair"></div><div style="float:left; width:32%;margin-bottom:110px;margin-top:40px;"><h1>Preventivo</h1></div><div style="float:right; width:33%;margin-bottom:110px;margin-top:40px;font-size:1.5em;"><p>GENIUS S.R.L. <br><br>(P. IVA 12972690155)<br><br> Via Soperga, 36 - 20127 MILANO.</p></div></div>',
      documentTitle: "Preventivo",
      maxWidth: 2500,
      scanStyles: true,
      targetStyles: ["*"],
      style: '@page { size: A3 portrait }',
      onError: error => {
        console.log("error print");
        console.log(error);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/estimate-card/estimate-card.component.ts